/*
  EMARQUE Product Sticky Bar
  ---------------------------
  Extracted from sections/product-sticky-bar.liquid (was an inline <script>).
  Loads via <script defer> so HTML parsing isn't blocked. Reads config from
  window.__emarqueStickyBars, which the section template populates inline.
  CSS still lives in the section's {% style %} block (uses {{ section.id }}
  for namespaced classes); this JS interacts via [data-sticky-*] attribute
  selectors which don't depend on section.id, so we only need the section
  root id to scope queries.
*/
(function () {
  function initStickyBar(config) {
    var sectionId = config.sectionId;
    var addToCartLabel = config.addToCartLabel;
    var showLabel = config.showLabel;
    var hideLabel = config.hideLabel;
    var shopCurrency = config.shopCurrency;

    var section = document.getElementById('sticky-bar-' + sectionId);
    if (!section) return;

    var compareEl = section.querySelector('[data-sticky-compare-at]');
    var savingsEl = section.querySelector('[data-sticky-savings]');
    var priceEl = section.querySelector('[data-sticky-price]');
    var btn = section.querySelector('[data-sticky-add-to-cart]');
    var btnLabel = section.querySelector('[data-sticky-btn-label]');
    var toggle = section.querySelector('[data-sticky-toggle]');
    var toggleLabel = section.querySelector('[data-sticky-toggle-label]');
    var info = section.querySelector('[data-sticky-info]');

    function findMainAddToCartBtn() {
      var candidates = document.querySelectorAll(
        'button[name="add"], button.product-form__submit, [id^="ProductSubmitButton"]'
      );
      for (var i = 0; i < candidates.length; i++) {
        if (!section.contains(candidates[i])) return candidates[i];
      }
      return null;
    }

    function findMainPriceContainer() {
      var candidates = document.querySelectorAll('.price__container');
      for (var i = 0; i < candidates.length; i++) {
        if (!section.contains(candidates[i])) return candidates[i];
      }
      return null;
    }

    function parseMoney(text) {
      if (!text) return null;
      var cleaned = String(text).replace(/[^0-9.,-]/g, '').replace(/,/g, '');
      var n = parseFloat(cleaned);
      return isNaN(n) ? null : n;
    }

    function formatSaving(amount) {
      try {
        return new Intl.NumberFormat('en-MY', {
          style: 'currency',
          currency: shopCurrency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (e) {
        return 'RM' + amount.toFixed(2);
      }
    }

    /* Easify-aware price reader — handles both Dawn's standard price markup
       and Easify Product Options' .tpo_product_price / .tpo_product_old_price
       overrides. */
    function readMainPrice() {
      var container = findMainPriceContainer();
      if (!container) return null;

      var priceBlock = container.closest('.price');
      var isOnSale = priceBlock && priceBlock.classList.contains('price--on-sale');
      var isSoldOut = priceBlock && priceBlock.classList.contains('price--sold-out');

      function pickVisible(nodes) {
        for (var i = 0; i < nodes.length; i++) {
          var n = nodes[i];
          if (n.classList.contains('visually-hidden')) continue;
          if (n.offsetParent === null && n.getClientRects().length === 0) continue;
          var s = window.getComputedStyle(n);
          if (s.display === 'none' || s.visibility === 'hidden') continue;
          return n;
        }
        return nodes[0] || null;
      }

      var priceText = '';
      var compareText = '';

      if (isOnSale) {
        var easifySale = container.querySelector('.price__sale .tpo_product_price');
        if (easifySale) {
          priceText = easifySale.textContent.trim();
        } else {
          var sale = pickVisible(container.querySelectorAll('.price__sale .price-item--sale.price-item--last'));
          if (sale) priceText = sale.textContent.trim();
        }

        var easifyCompare = container.querySelector('.tpo_product_old_price');
        if (easifyCompare) {
          compareText = easifyCompare.textContent.trim();
        } else {
          var cmp = pickVisible(container.querySelectorAll('.price__sale s.price-item--regular'));
          if (cmp) compareText = cmp.textContent.trim();
        }
      } else {
        var easifyReg = container.querySelector('.price__regular .tpo_product_price');
        if (easifyReg) {
          priceText = easifyReg.textContent.trim();
        } else {
          var reg = pickVisible(container.querySelectorAll('.price__regular .price-item--regular'));
          if (reg) priceText = reg.textContent.trim();
        }
      }

      return {
        priceText: priceText,
        compareText: compareText,
        isOnSale: isOnSale,
        isSoldOut: isSoldOut
      };
    }

    function syncPrice() {
      var data = readMainPrice();
      if (!data) return;

      if (priceEl && data.priceText) priceEl.textContent = data.priceText;

      var priceVal = parseMoney(data.priceText);
      var compareVal = parseMoney(data.compareText);

      if (compareVal && priceVal && compareVal > priceVal) {
        if (compareEl) {
          compareEl.textContent = data.compareText;
          compareEl.style.display = '';
        }
        if (savingsEl) {
          savingsEl.textContent = 'Save ' + formatSaving(compareVal - priceVal);
          savingsEl.style.display = '';
        }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (savingsEl) savingsEl.style.display = 'none';
      }
    }

    function syncButton() {
      if (!btn) return;
      var mainBtn = findMainAddToCartBtn();
      if (!mainBtn) {
        btn.disabled = true;
        return;
      }

      var mainDisabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
      btn.disabled = mainDisabled;

      if (btnLabel) {
        var mainText = (mainBtn.textContent || '').trim();
        if (mainDisabled && /sold out|unavailable/i.test(mainText)) {
          btnLabel.textContent = 'Sold out';
        } else {
          btnLabel.textContent = addToCartLabel;
        }
      }
    }

    /* Push floating chat / WhatsApp widgets above the sticky bar at runtime
       as a fallback for app embeds with non-standard class names that the
       CSS body-class-scoped selectors don't catch. */
    function offsetFloatingChatButtons(stickyHeight) {
      var selectorString =
        '[id*="seedgrow" i], [class*="seedgrow" i], ' +
        '[id^="swc-"], [class*="swc-"], ' +
        '[class*="whatsapp" i], ' +
        '[id*="whatsapp" i], ' +
        '[class*="wa-button" i], ' +
        '[class*="wa-chat" i], ' +
        '.wa__btn_popup, ' +
        '#wa_btn_popup, ' +
        '[class*="wa__chat"], [id*="wa__chat"], ' +
        '[class*="wa__pop"], [id*="wa__pop"], ' +
        '[class*="wa__widget"], [id*="wa__widget"]';

      var candidates;
      try {
        candidates = document.querySelectorAll(selectorString);
      } catch (e) {
        return;
      }

      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (section.contains(el)) continue;

        var cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed') continue;

        var rect = el.getBoundingClientRect();
        if (rect.height === 0 || rect.width === 0) continue;
        if (rect.bottom > window.innerHeight + 50) continue;

        el.style.setProperty('bottom', (stickyHeight + 16) + 'px', 'important');
        el.style.setProperty('transition', 'bottom 0.18s ease', '');
      }
    }

    var rafSync = false;
    function scheduleSync() {
      if (rafSync) return;
      rafSync = true;
      requestAnimationFrame(function () {
        rafSync = false;
        syncPrice();
        syncButton();
      });
    }

    var rafHeight = false;
    function scheduleHeightSync() {
      if (rafHeight) return;
      rafHeight = true;
      requestAnimationFrame(function () {
        rafHeight = false;
        var h = section.offsetHeight;
        if (h) {
          document.body.style.setProperty('--sticky-bar-height', h + 'px');
          offsetFloatingChatButtons(h);
        }
      });
    }

    /* Visual Viewport sync — lifts the bar above iOS Safari / Chrome mobile's
       dynamic bottom toolbar when it reveals on scroll.

       Threshold: small fluctuations (1-30px) leak through from iOS Safari's
       URL-bar collapse/expand transitions even when no bottom toolbar is
       visible, producing a "phantom gap" below the bar. iOS Chrome's actual
       bottom toolbar is ~50-60px tall. Clamping insets below 40px to zero
       eliminates the phantom gap while preserving the genuine lift behaviour
       when Chrome's bottom toolbar reveals. */
    var rafVV = false;
    function syncVisualViewportOffset() {
      if (!window.visualViewport) return;
      if (rafVV) return;
      rafVV = true;
      requestAnimationFrame(function () {
        rafVV = false;
        var vv = window.visualViewport;
        var rawInset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
        var inset = rawInset < 40 ? 0 : rawInset;
        document.body.style.setProperty('--sticky-bar-chrome-inset', inset + 'px');
      });
    }

    /* HTML5 form="<id>" association — when sticky button is clicked, the
       browser natively submits the main product form. Critical: use
       mainForm.getAttribute('id'), NOT mainForm.id (the latter returns the
       hidden <input name="id"> via named-child shadowing). */
    var nativeSubmitWired = false;
    function wireNativeSubmit() {
      if (nativeSubmitWired || !btn) return nativeSubmitWired;
      var mainBtn = findMainAddToCartBtn();
      if (!mainBtn) return false;
      var mainForm = mainBtn.closest('form');
      if (!mainForm) return false;

      var formId = mainForm.getAttribute('id');
      if (!formId) {
        formId = 'sticky-bar-target-form-' + sectionId;
        mainForm.setAttribute('id', formId);
      }

      btn.setAttribute('form', formId);
      btn.setAttribute('type', 'submit');
      btn.setAttribute('name', 'add');
      nativeSubmitWired = true;
      return true;
    }

    if (!wireNativeSubmit()) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', wireNativeSubmit, { once: true });
      }
      window.addEventListener('load', wireNativeSubmit, { once: true });
      var pollCount = 0;
      var pollId = setInterval(function () {
        if (wireNativeSubmit() || ++pollCount > 20) clearInterval(pollId);
      }, 250);
    }

    /* Easify priced-upgrade fee injection — sticky button submits via
       form="..." which fires submit but NOT Easify's click handler. So we
       replicate Easify's _tpo_price + _tpo_custom_options form injection
       so Shopify Functions (cart transform) applies the upgrade fee.
       Without this the cart line lands at the variant's base price and
       Easify's reconcile removes it. */
    if (btn) {
      btn.addEventListener('click', function () {
        var mainBtn = findMainAddToCartBtn();
        if (!mainBtn) return;
        var mainForm = mainBtn.closest('form');
        if (!mainForm) return;

        // Match ALL property fields, incl <select>/<textarea> — not just <input>.
        // A priced Easify option rendered as a dropdown must be summed too, else
        // _tpo_price is understated and Easify's reconcile removes the line (§11.12).
        var propInputs = mainForm.querySelectorAll('[name^="properties["]');
        if (!propInputs.length) return;

        var customOpts = {};
        var totalUpgrade = 0;
        for (var i = 0; i < propInputs.length; i++) {
          var inp = propInputs[i];
          var nameMatch = inp.name.match(/^properties\[(.+)\]$/);
          if (!nameMatch) continue;
          var key = nameMatch[1];
          if (key.indexOf('_tpo_') === 0) continue;
          customOpts[key] = inp.value;
          var priceMatch = inp.value.match(/\[\s*\+RM\s*([\d,]+(?:\.\d+)?)\s*\]/);
          if (priceMatch) {
            totalUpgrade += parseFloat(priceMatch[1].replace(/,/g, ''));
          }
        }

        var setOrCreateInput = function (name, value) {
          var existing = mainForm.querySelector('input[name="' + name + '"]');
          if (!existing) {
            existing = document.createElement('input');
            existing.type = 'hidden';
            existing.name = name;
            mainForm.appendChild(existing);
          }
          existing.value = value;
        };

        setOrCreateInput('properties[_tpo_price]', String(Math.round(totalUpgrade)));
        setOrCreateInput('properties[_tpo_custom_options]', JSON.stringify(customOpts));
      });
    }

    /* Mobile collapse toggle. */
    if (toggle && info) {
      toggle.addEventListener('click', function () {
        var expanded = info.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (toggleLabel) toggleLabel.textContent = expanded ? hideLabel : showLabel;
        scheduleHeightSync();
      });
    }

    function init() {
      scheduleSync();
      scheduleHeightSync();

      /* Narrow MutationObservers — separate observer per concern, scoped to
         the specific node whose changes affect that concern. Replaces an
         earlier wide observer that watched the entire <product-info> with
         characterData:true (10+ fires per Easify variant click). */
      var priceTarget = findMainPriceContainer();
      if (priceTarget) {
        var priceObserver = new MutationObserver(scheduleSync);
        priceObserver.observe(priceTarget, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      var btnTarget = findMainAddToCartBtn();
      if (btnTarget) {
        var btnObserver = new MutationObserver(scheduleSync);
        btnObserver.observe(btnTarget, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class']
        });
      }

      window.addEventListener('resize', scheduleHeightSync, { passive: true });

      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', syncVisualViewportOffset, { passive: true });
        window.visualViewport.addEventListener('scroll', syncVisualViewportOffset, { passive: true });
        syncVisualViewportOffset();
      }

      /* App-switch resync — when user backgrounds Chrome and returns, the
         Visual Viewport API doesn't fire scroll/resize even though Chrome's
         bottom toolbar state may have changed. CSS variable stays stale,
         bar renders in wrong position until next scroll. Triggering resync
         on visibilitychange + pageshow eliminates the glitch.
         Staggered setTimeouts catch any late toolbar reveal animations
         that complete after the initial paint. */
      function resyncViewport() {
        scheduleHeightSync();
        syncVisualViewportOffset();
        setTimeout(syncVisualViewportOffset, 250);
        setTimeout(syncVisualViewportOffset, 750);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') resyncViewport();
      });
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) resyncViewport();
      });

      /* Re-run height sync (+ floating chat-button offset) a few times after
         page load since app embeds often inject their widget asynchronously. */
      setTimeout(scheduleHeightSync, 400);
      setTimeout(scheduleHeightSync, 1500);
      setTimeout(scheduleHeightSync, 4000);
    }

    init();
  }

  function initAll() {
    var configs = window.__emarqueStickyBars || [];
    for (var i = 0; i < configs.length; i++) {
      initStickyBar(configs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
